// extracted by mini-css-extract-plugin
export default {"container":"CentralGridLayout_container__46Qqn"};